import { createTheme } from '@mui/material/styles';
import {
  BRAND_COBALT,
  BRAND_COBALT_DEEP,
  BRAND_COBALT_LITE,
  CYAN,
  ACCENT_GOLD,
  ACCENT_FIRE,
  INK,
  WHITE,
  N800,
} from './styles/tokens';

/*
 * MUI theme. The visual single source of truth is styles/tokens.css; CSS,
 * inline styles and `sx`/styleOverrides reference var(--…). The `palette`,
 * however, is augmented eagerly by MUI (it computes light/dark variants via
 * decomposeColor, which can't parse a var() string), so palette anchors use
 * the raw hexes from styles/tokens.ts — which mirror tokens.css.
 */
const theme = createTheme({
  palette: {
    primary: {
      main: BRAND_COBALT,
      dark: BRAND_COBALT_DEEP,
      light: BRAND_COBALT_LITE,
      contrastText: '#ffffff',
    },
    secondary: {
      main: WHITE,
      contrastText: BRAND_COBALT,
    },
    success: {
      main: CYAN,
      contrastText: '#ffffff',
    },
    warning: {
      main: ACCENT_GOLD,
      contrastText: INK,
    },
    error: {
      main: ACCENT_FIRE,
      contrastText: '#ffffff',
    },
    text: {
      primary: N800,
    },
  },
  typography: {
    fontFamily: 'var(--font)',
    fontSize: 14,
    h1: { fontFamily: 'var(--display)', fontWeight: 400, fontSize: '2rem' },
    h2: { fontFamily: 'var(--display)', fontWeight: 400, fontSize: '1.75rem' },
    h3: { fontFamily: 'var(--display)', fontWeight: 400, fontSize: '1.5rem' },
    h4: { fontFamily: 'var(--display)', fontWeight: 400 },
    h5: { fontFamily: 'var(--display)', fontWeight: 400 },
    h6: { fontFamily: 'var(--display)', fontWeight: 400 },
    body1: {
      fontSize: '14px',
    },
    body2: {
      fontSize: '14px',
    },
    caption: {
      fontSize: '10px',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '&::-webkit-scrollbar': {
          display: 'none',
        },

        '&::-webkit-scrollbar-thumb': {
          background: 'var(--n200)',
          borderRadius: '3px',
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.5rem',
          padding: '0.75rem 1.5rem',
          fontSize: '1rem',
          fontWeight: 600,
          color: 'var(--brand-cobalt)',
          textTransform: 'none',
          backgroundColor: 'var(--white)',
          borderRadius: 'var(--r-md)',
          cursor: 'pointer',
          transition: 'background-color 0.1s, transform 0.1s',
          outline: 'none',
          boxShadow: 'none',
          '&.Mui-disabled': {
            backgroundColor: 'var(--white)',
            cursor: 'not-allowed',
          },
          // The root above paints every variant white, so `contained` (the
          // primary action) needs its fill back: the same cobalt as the shared
          // `.dg-btn-primary` in styles/ui.css. Two classes outrank the root's
          // one, disabled included.
          '&.MuiButton-contained': {
            backgroundColor: 'var(--brand-cobalt)',
            color: 'var(--white)',
          },
          '&.MuiButton-contained:hover': {
            backgroundColor: 'var(--brand-cobalt-deep)',
          },
          '&.MuiButton-contained.Mui-disabled': {
            backgroundColor: 'var(--brand-cobalt)',
            color: 'var(--white)',
            opacity: 0.45,
          },
        },
      },
    },
  },
});

export default theme;
